export default __webpack_public_path__ + "static/media/2R.b5523c9e.png";